export const serviceCategories = [
  {
    id: 'igaming-fx-licensing',
    title: 'iGaming & FX Licensing',
    description:
      'We support gaming operators and forex brokers with end-to-end licensing services across Malta, Cyprus, and other key jurisdictions, helping you enter the market with clarity and compliance.',
    image:
      'https://public.readdy.ai/ai/img_res/642141cda54b38137f8b21f02c1202c7.jpg',
    services: [
      'Malta Gaming Authority (MGA) License',
      'Curaçao Gaming License',
      'CySEC Forex Broker License',
      'FCA Authorization Support',
      'License Application Preparation',
      'Ongoing Compliance Management',
    ],
  },
  {
    id: 'aml-kyc-outsourcing',
    title: 'AML & KYC Outsourcing',
    description:
      'Comprehensive Anti-Money Laundering and Know Your Customer services to ensure your business stays compliant with all regulatory requirements while providing accurate and timely processing.',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20abstract%20shield%20protection%20concept%20with%20geometric%20patterns%20and%20flowing%20lines%20in%20deep%20navy%20and%20amber%20gold%20colors%20representing%20security%20and%20compliance%20professional%20corporate%20aesthetic&width=600&height=400&seq=compliance1&orientation=landscape',
    services: [
      'Customer Due Diligence (CDD)',
      'Enhanced Due Diligence (EDD)',
      'Sanctions Screening',
      'PEP Screening',
      'Transaction Monitoring',
      'Suspicious Activity Reporting',
      'AML Risk Assessments',
      'KYC Policy Development',
    ],
  },
  {
    id: 'compliance-outsourcing',
    title: 'Compliance Outsourcing',
    description:
      'We help businesses meet their regulatory obligations with confidence, offering practical support in compliance frameworks, risk assessments, and adherence to FIAU, MFSA, CySEC and EU standards.',
    image:
      'https://readdy.ai/api/search-image?query=Business%20professionals%20in%20meeting%20reviewing%20documents%20with%20teamwork%20and%20collaboration%20modern%20office%20setting%20professional%20corporate%20environment%20warm%20lighting&width=600&height=400&seq=compliance2&orientation=landscape',
    services: [
      'Compliance Officer Services',
      'MLRO Services',
      'Regulatory Reporting',
      'Compliance Audits',
      'Policy & Procedure Development',
      'GDPR Compliance',
      'DORA Compliance',
      'Regulatory Visit Preparation',
    ],
  },
  {
    id: 'tax-payroll-outsourcing',
    title: 'Tax & Payroll Outsourcing',
    description:
      'Navigating the complexities of tax and social insurance can be challenging for businesses of all sizes. We provide comprehensive payroll and tax services to ensure your business stays compliant.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20financial%20growth%20visualization%20with%20ascending%20geometric%20bars%20and%20flowing%20golden%20light%20streams%20on%20dark%20sophisticated%20background%20representing%20wealth%20management%20and%20tax%20strategy%20modern%20minimal%20design&width=600&height=400&seq=tax1&orientation=landscape',
    services: [
      'Corporate Tax Planning',
      'Personal Tax Advisory',
      'VAT Registration & Compliance',
      'Payroll Processing',
      'Social Insurance Management',
      'Tax Return Preparation',
      'Transfer Pricing',
      'Tax Incentive Applications',
    ],
  },
  {
    id: 'accounting-outsourcing',
    title: 'Accounting Outsourcing',
    description:
      "In today's fast-paced business world, accurate and efficient accounting is essential to the financial health of any organization. We offer comprehensive accounting services tailored to your needs.",
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20elegant%20financial%20documents%20charts%20and%20graphs%20displayed%20on%20sleek%20tablet%20device%20soft%20natural%20lighting%20minimalist%20professional%20office%20environment%20warm%20neutral%20tones&width=600&height=400&seq=accounting1&orientation=landscape',
    services: [
      'Bookkeeping Services',
      'Financial Reporting',
      'Management Accounts',
      'Audit Coordination',
      'Financial Statement Preparation',
      'Budget Planning & Analysis',
      'Cash Flow Management',
      'Year-End Accounts',
    ],
  },
  {
    id: 'legal-drafting-outsourcing',
    title: 'Legal Drafting Outsourcing',
    description:
      'Clear and comprehensive policies and procedures are crucial for any organization. We provide specialized legal drafting services with a professional touch, ensuring precision and accuracy.',
    image:
      'https://readdy.ai/api/search-image?query=Sophisticated%20legal%20concept%20with%20abstract%20scales%20of%20justice%20rendered%20in%20modern%20geometric%20style%20deep%20navy%20blue%20and%20gold%20accents%20professional%20law%20firm%20aesthetic%20elegant%20and%20authoritative&width=600&height=400&seq=legal1&orientation=landscape',
    services: [
      'AML/KYC Policies & Procedures',
      'Terms & Conditions',
      'Privacy Policies',
      'Employment Contracts',
      'Service Agreements',
      'Board Minutes & Resolutions',
      'Shareholder Agreements',
      'Commercial Contracts',
    ],
  },
  {
    id: 'company-formation',
    title: 'Company Formation Services',
    description:
      'Starting a new business requires navigating the complex process of company registration. We offer comprehensive company formation services to help you establish your business quickly and efficiently.',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20modern%20glass%20skyscraper%20architecture%20with%20dramatic%20angular%20reflections%20at%20golden%20hour%20sunset%20light%20creating%20warm%20amber%20tones%20on%20sleek%20corporate%20building%20facade%20professional%20business%20aesthetic&width=600&height=400&seq=corporate1&orientation=landscape',
    services: [
      'Cyprus Company Formation',
      'Malta Company Formation',
      'UK Company Formation',
      'Registered Office Services',
      'Nominee Director Services',
      'Company Secretary Services',
      'Corporate Restructuring',
      'Annual Compliance Filings',
    ],
  },
];

export const serviceStats = [
  { value: '500+', label: 'Clients Served' },
  { value: '15+', label: 'Years Experience' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '24/7', label: 'Support Available' },
];

export const serviceDetails = {
  'igaming-fx-licensing': {
    id: 'igaming-fx-licensing',
    title: 'iGaming & FX License Marketplace',
    subtitle: 'Acquire a Ready-to-Use, Already-Issued License — Skip the Queue, Start Operating Faster',
    heroImage: 'https://readdy.ai/api/search-image?query=Dramatic%20aerial%20view%20of%20a%20global%20financial%20trading%20floor%20with%20glowing%20screens%20showing%20world%20maps%20and%20currency%20symbols%20warm%20amber%20and%20deep%20charcoal%20tones%20sleek%20modern%20architecture%20representing%20international%20license%20brokerage%20and%20financial%20markets%20premium%20corporate%20aesthetic&width=1920&height=600&seq=igaming-hero2&orientation=landscape',
    description: 'We run a specialist marketplace for already-issued iGaming and Forex licenses. We do not apply for new licenses. Instead, we connect you directly with verified license holders who are ready to sell. Buying an existing license is faster, cheaper, and more certain than applying from scratch — and we manage the entire process for you.',
    longDescription: 'A fresh license application can take 6–18 months. There is no guarantee of approval. Costs add up quickly. Buying an already-issued license removes all of that uncertainty.\n\nEvery license in our portfolio is verified before listing. We check it is currently active, in good regulatory standing, and free from sanctions or enforcement actions. We then match you with the right license for your jurisdiction, budget, and timeline.\n\nWe handle everything from first contact to final transfer — matching, due diligence, negotiation support, and legal handover. You focus on launching your business. We handle the rest.',
    whyCyprus: {
      title: 'Why Buy an Already-Issued License?',
      benefits: [
        {
          icon: 'ri-timer-flash-line',
          title: 'Immediate Market Entry',
          description: 'Skip the 6–18 month application process entirely. An already-issued license means you can begin operations as soon as the transfer is complete.'
        },
        {
          icon: 'ri-shield-check-line',
          title: 'Verified & In Good Standing',
          description: 'Every license in our portfolio is verified for current validity, regulatory standing, and absence of sanctions or enforcement actions before listing.'
        },
        {
          icon: 'ri-money-dollar-circle-line',
          title: 'Cost-Effective Acquisition',
          description: 'Avoid costly application fees, legal preparation costs, and the risk of rejection. Buying an existing license is often more economical than applying from scratch.'
        },
        {
          icon: 'ri-shake-hands-line',
          title: 'Managed Transaction Process',
          description: 'We handle the matching, negotiation support, due diligence coordination, and transfer documentation — so you can focus on your business.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Tell Us What You Need',
        description: 'Share your target jurisdiction, license type (Forex or iGaming), budget, and timeline. We match you with available licenses from our seller network.'
      },
      {
        step: '02',
        title: 'Review Available Licenses',
        description: 'We present you with verified, available licenses that match your criteria, including jurisdiction details, current status, and acquisition terms.'
      },
      {
        step: '03',
        title: 'Due Diligence & Agreement',
        description: 'We coordinate due diligence on the selected license and support both parties through the negotiation and sale agreement process.'
      },
      {
        step: '04',
        title: 'Transfer & Handover',
        description: 'We facilitate the legal transfer of the license to the buyer, ensuring all regulatory notifications and ownership change procedures are completed correctly.'
      }
    ],
    subServices: [
      {
        icon: 'ri-global-line',
        flag: '🇸🇨',
        title: 'Seychelles Forex License',
        description: 'FSA-regulated Seychelles Securities Dealer license — a respected offshore jurisdiction offering a cost-effective and internationally recognized framework for forex brokers.'
      },
      {
        icon: 'ri-map-pin-2-line',
        flag: '🇻🇺',
        title: 'Vanuatu Forex License',
        description: 'VFSC-issued Forex Dealer license from Vanuatu — fast to transfer, low ongoing costs, and widely accepted by liquidity providers and payment processors.'
      },
      {
        icon: 'ri-anchor-line',
        flag: '🇲🇺',
        title: 'Mauritius Forex License',
        description: 'FSC Mauritius Investment Dealer license — a reputable mid-shore jurisdiction with strong regulatory credibility and access to African and Asian markets.'
      },
      {
        icon: 'ri-compass-3-line',
        flag: '🇰🇲',
        title: 'Comoros Forex License',
        description: 'MISA-issued Comoros forex license — an accessible offshore option for brokers seeking a quick and affordable entry point into regulated forex operations.'
      },
      {
        icon: 'ri-flag-line',
        flag: '🇰🇪',
        title: 'Kenya Forex License',
        description: 'CMA Kenya-regulated forex broker license — ideal for operators targeting the fast-growing East African retail trading market with a credible local regulatory stamp.'
      },
      {
        icon: 'ri-bank-line',
        flag: '🇨🇾',
        title: 'CySEC Forex License (CIF)',
        description: 'Cyprus Investment Firm license regulated by CySEC under MiFID II — the gold standard for EU-passported forex operations, granting access to all 27 EU member states.'
      },
      {
        icon: 'ri-gamepad-line',
        flag: '🇱🇷',
        title: 'Liberia iGaming License',
        description: 'Liberia-issued online gaming license — a flexible offshore license suitable for casino, sports betting, and poker operators seeking broad international reach.'
      },
      {
        icon: 'ri-dice-line',
        flag: '🇨🇼',
        title: 'Curaçao iGaming License',
        description: 'One of the most widely recognized iGaming licenses globally. Curaçao eGaming licenses are accepted by major software providers and payment processors worldwide.'
      },
      {
        icon: 'ri-trophy-line',
        flag: '🇰🇲',
        title: 'Anjouan iGaming License',
        description: 'Anjouan (Comoros) online gaming license — a growing offshore jurisdiction offering a straightforward licensing framework for casino and sports betting operators.'
      },
      {
        icon: 'ri-gamepad-line',
        flag: '🇨🇷',
        title: 'Costa Rica iGaming License',
        description: 'Costa Rica data processing license for online gaming — a popular choice for operators targeting Latin American and global markets with minimal regulatory burden.'
      }
    ],
    faqs: [
      {
        question: 'Do you help apply for new licenses?',
        answer: 'No. Our service is exclusively a license marketplace. We connect buyers with individuals or companies who already hold valid, issued licenses and are willing to sell. We do not submit new license applications on behalf of clients. If you need a fresh application, we can refer you to appropriate specialists, but our core offering is the acquisition of existing licenses.'
      },
      {
        question: 'How do I know the license is genuine and in good standing?',
        answer: 'Before any license is listed in our marketplace, we conduct a verification process that includes confirming the license is currently active with the issuing authority, checking for any regulatory sanctions, enforcement actions, or conditions attached to the license, and reviewing the ownership structure. We share full verification documentation with serious buyers during the due diligence phase.'
      },
      {
        question: 'How long does the transfer process take?',
        answer: 'Transfer timelines vary by jurisdiction. Offshore licenses (Vanuatu, Seychelles, Comoros, Anjouan, Costa Rica, Liberia) can often be transferred within 4–8 weeks. Mid-shore and regulated licenses such as Mauritius FSC, Kenya CMA, and CySEC CIF involve regulatory notification or approval and may take 2–6 months. We provide a realistic timeline estimate for each specific license before you commit.'
      },
      {
        question: 'Can I see what licenses are currently available?',
        answer: 'Yes. Contact us with your requirements — license type, jurisdiction preference, and budget — and we will share the current availability from our seller network. Availability changes regularly as licenses are acquired and new sellers come to market, so we recommend reaching out directly for the most up-to-date inventory.'
      },
      {
        question: 'What is your role in the transaction — do you represent the buyer or seller?',
        answer: 'We act as an independent marketplace facilitator. We do not exclusively represent either party. Our role is to match buyers and sellers, coordinate due diligence, support negotiations, and ensure the transfer process is handled correctly. Both parties benefit from our expertise in license transactions and regulatory requirements across all listed jurisdictions.'
      }
    ]
  },
  'aml-kyc-outsourcing': {
    id: 'aml-kyc-outsourcing',
    title: 'AML & KYC Outsourcing',
    subtitle: 'Comprehensive Anti-Money Laundering and Know Your Customer Solutions',
    heroImage: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20identity%20verification%20concept%20with%20glowing%20biometric%20fingerprint%20scan%20holographic%20data%20streams%20and%20secure%20network%20connections%20deep%20blue%20and%20cyan%20colors%20representing%20cybersecurity%20and%20compliance%20technology&width=1920&height=600&seq=aml-hero&orientation=landscape',
    description: 'Regulators are scrutinising AML and KYC compliance more than ever. Cyprus AML Law 188(I)/2007 — aligned with EU 4th and 5th AML Directives — places strict obligations on all regulated businesses. Failing to comply carries serious penalties. We take this off your plate entirely, handling customer due diligence, transaction monitoring, and MOKAS reporting so you can focus on running your business.',
    longDescription: 'AML and KYC compliance is complex. It requires the right technology, experienced people, and constant attention. Building that in-house is expensive. Outsourcing to us is not.\n\nWe screen customers against global sanctions lists and PEP databases. We conduct CDD for standard customers and EDD for high-risk ones. We monitor transactions for suspicious patterns and prepare detailed reports for MOKAS submission.\n\nWe work with banks, forex brokers, gaming operators, crypto businesses, and other regulated firms. Whatever your sector, we tailor our service to your specific obligations and risk profile.',
    whyCyprus: {
      title: 'Why Outsource AML & KYC to Cyprus Specialists?',
      benefits: [
        {
          icon: 'ri-shield-check-line',
          title: 'EU Compliance Expertise',
          description: 'Deep knowledge of Cyprus AML Law 188(I)/2007, EU AML Directives, and MOKAS reporting requirements for comprehensive compliance.'
        },
        {
          icon: 'ri-funds-line',
          title: 'Cost-Effective Solutions',
          description: 'Reduce operational costs by up to 60% compared to maintaining in-house AML teams while accessing specialized expertise.'
        },
        {
          icon: 'ri-time-line',
          title: '24/7 Monitoring',
          description: 'Round-the-clock transaction monitoring and customer screening to detect suspicious activities in real-time across all time zones.'
        },
        {
          icon: 'ri-database-2-line',
          title: 'Advanced Technology',
          description: 'State-of-the-art AML software platforms with AI-powered risk scoring, automated screening, and comprehensive audit trails.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Risk Assessment',
        description: 'We conduct a comprehensive risk assessment of your business model, customer base, and transaction patterns to design tailored AML procedures.'
      },
      {
        step: '02',
        title: 'System Integration',
        description: 'Our team integrates with your existing systems to enable seamless data flow for customer onboarding and transaction monitoring.'
      },
      {
        step: '03',
        title: 'Ongoing Monitoring',
        description: 'Continuous customer screening, transaction monitoring, and periodic reviews to identify and investigate suspicious activities.'
      },
      {
        step: '04',
        title: 'Reporting & Documentation',
        description: 'Preparation of suspicious activity reports (SARs) for MOKAS submission and maintenance of comprehensive compliance records.'
      }
    ],
    subServices: [
      {
        icon: 'ri-user-search-line',
        title: 'Customer Due Diligence (CDD)',
        description: 'Comprehensive identity verification, source of funds checks, and risk profiling for all customers during onboarding.'
      },
      {
        icon: 'ri-shield-user-line',
        title: 'Enhanced Due Diligence (EDD)',
        description: 'In-depth investigation and ongoing monitoring for high-risk customers, PEPs, and complex corporate structures.'
      },
      {
        icon: 'ri-global-line',
        title: 'Sanctions Screening',
        description: 'Real-time screening against OFAC, UN, EU, and other global sanctions lists to prevent prohibited transactions.'
      },
      {
        icon: 'ri-vip-crown-line',
        title: 'PEP Screening',
        description: 'Identification and monitoring of Politically Exposed Persons and their close associates across global databases.'
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Transaction Monitoring',
        description: 'Automated monitoring of customer transactions to detect unusual patterns, structuring, and potential money laundering.'
      },
      {
        icon: 'ri-file-warning-line',
        title: 'Suspicious Activity Reporting',
        description: 'Preparation and submission of detailed SARs to MOKAS when suspicious activities are identified.'
      },
      {
        icon: 'ri-bar-chart-box-line',
        title: 'AML Risk Assessments',
        description: 'Periodic business-wide risk assessments to identify vulnerabilities and update AML policies and procedures.'
      },
      {
        icon: 'ri-file-text-line',
        title: 'KYC Policy Development',
        description: 'Creation and maintenance of comprehensive KYC policies, procedures, and training materials for your organization.'
      }
    ],
    faqs: [
      {
        question: 'What is the difference between CDD and EDD?',
        answer: 'Customer Due Diligence (CDD) is the standard level of verification required for all customers, including identity verification and basic risk assessment. Enhanced Due Diligence (EDD) is a more rigorous process applied to high-risk customers, PEPs, or complex transactions, involving deeper investigation of source of funds, beneficial ownership, and ongoing monitoring.'
      },
      {
        question: 'How quickly can you onboard new customers with KYC checks?',
        answer: 'Standard CDD checks are typically completed within 24-48 hours for straightforward cases. EDD procedures may take 3-5 business days depending on complexity. We offer expedited services for urgent cases while maintaining full compliance standards.'
      },
      {
        question: 'Do you report directly to MOKAS on our behalf?',
        answer: 'We prepare comprehensive suspicious activity reports (SARs) with all required documentation and analysis. However, the legal obligation to submit reports to MOKAS remains with your organization as the obliged entity. We can assist with the submission process and maintain all necessary records.'
      },
      {
        question: 'Can you handle AML compliance for crypto businesses?',
        answer: 'Yes, we have extensive experience with crypto asset service providers (CASPs) and understand the unique AML challenges in the crypto sector, including blockchain analysis, wallet screening, and compliance with the EU Travel Rule for crypto transfers.'
      }
    ]
  },
  'compliance-outsourcing': {
    id: 'compliance-outsourcing',
    title: 'Compliance Outsourcing',
    subtitle: 'Expert Regulatory Compliance Solutions for Cyprus-Based Businesses',
    heroImage: 'https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Limassol%20Cyprus%20modern%20business%20district%20at%20golden%20hour%20with%20gleaming%20glass%20skyscrapers%20reflecting%20sunset%20light%20Mediterranean%20Sea%20in%20background%20dynamic%20urban%20skyline%20representing%20corporate%20excellence%20and%20regulatory%20compliance&width=1920&height=600&seq=compliance-hero&orientation=landscape',
    description: 'Cyprus is a leading EU financial services hub. It is regulated by CySEC, the Central Bank of Cyprus, and the FIAU. Operating here means meeting strict rules under MiFID II, UCITS, AIFMD, and local law. We handle all of that for you. Our compliance outsourcing service gives your business full regulatory support — so you can focus on growth.',
    longDescription: 'Cyprus combines EU directives with local rules. This creates a demanding compliance environment. CySEC-regulated firms must meet MiFID II standards: best execution, client categorisation, and transaction reporting. Payment institutions must follow PSD2. Insurance firms have their own separate obligations.\n\nWe act as an extension of your team. We provide compliance officer and MLRO services, prepare regulatory reports, run internal audits, and monitor your business on an ongoing basis. The result: your licence stays in good standing and you avoid costly penalties.',
    whyCyprus: {
      title: 'Why Choose Cyprus for Your Compliance Operations?',
      benefits: [
        {
          icon: 'ri-shield-star-line',
          title: 'Robust EU Regulatory Framework',
          description: 'Cyprus implements all EU financial services directives including MiFID II, UCITS, AIFMD, and PSD2, providing a comprehensive and internationally recognized regulatory environment.'
        },
        {
          icon: 'ri-government-line',
          title: 'Experienced Regulators',
          description: 'CySEC and CBC have decades of experience supervising financial institutions, with clear guidance, responsive communication, and pragmatic approach to regulation.'
        },
        {
          icon: 'ri-file-shield-2-line',
          title: 'Comprehensive Legal Framework',
          description: 'Cyprus Companies Law Cap.113, Prevention and Suppression of Money Laundering Law, and sector-specific regulations provide clear legal foundation for business operations.'
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'Professional Services Hub',
          description: 'Access to experienced compliance professionals, lawyers, auditors, and consultants with deep knowledge of Cyprus and EU regulatory requirements.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Compliance Gap Analysis',
        description: 'We conduct a thorough assessment of your current compliance framework against CySEC, FIAU, and relevant EU regulatory requirements to identify gaps and priorities.'
      },
      {
        step: '02',
        title: 'Framework Implementation',
        description: 'Our team develops and implements comprehensive compliance policies, procedures, and controls tailored to your business model and regulatory obligations.'
      },
      {
        step: '03',
        title: 'Ongoing Monitoring',
        description: 'Continuous monitoring of regulatory changes, internal controls, and business activities to ensure ongoing compliance and early identification of issues.'
      },
      {
        step: '04',
        title: 'Regulatory Liaison',
        description: 'We manage all communications with CySEC, FIAU, and other regulators, including regulatory reporting, license renewals, and response to regulatory inquiries.'
      }
    ],
    subServices: [
      {
        icon: 'ri-user-star-line',
        title: 'Compliance Officer Services',
        description: 'Experienced compliance officers acting as your designated compliance function, ensuring adherence to all regulatory requirements and internal policies.'
      },
      {
        icon: 'ri-shield-user-line',
        title: 'MLRO Services',
        description: 'Dedicated Money Laundering Reporting Officer services for FIAU-regulated entities, managing AML compliance and MOKAS reporting obligations.'
      },
      {
        icon: 'ri-file-chart-line',
        title: 'Regulatory Reporting',
        description: 'Preparation and submission of all required regulatory reports to CySEC, CBC, FIAU, and other authorities, ensuring accuracy and timeliness.'
      },
      {
        icon: 'ri-search-eye-line',
        title: 'Compliance Audits',
        description: 'Regular internal compliance audits to assess effectiveness of controls, identify weaknesses, and recommend improvements before regulatory inspections.'
      },
      {
        icon: 'ri-file-list-2-line',
        title: 'Policy & Procedure Development',
        description: 'Creation and maintenance of comprehensive compliance manuals, policies, procedures, and training materials aligned with regulatory requirements.'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'GDPR Compliance',
        description: 'Full GDPR compliance services including data protection impact assessments, privacy policies, consent management, and breach notification procedures.'
      },
      {
        icon: 'ri-server-line',
        title: 'DORA Compliance',
        description: 'Digital Operational Resilience Act compliance for financial entities, covering ICT risk management, incident reporting, and third-party risk management.'
      },
      {
        icon: 'ri-presentation-line',
        title: 'Regulatory Visit Preparation',
        description: 'Comprehensive preparation for CySEC or FIAU on-site inspections, including documentation review, staff training, and mock inspections.'
      }
    ],
    faqs: [
      {
        question: 'What is the role of a Compliance Officer in a CySEC-regulated firm?',
        answer: 'The Compliance Officer is responsible for ensuring the firm complies with all applicable laws, regulations, and internal policies. This includes monitoring regulatory changes, conducting compliance reviews, providing compliance advice to management, overseeing staff training, and serving as the primary contact with CySEC on compliance matters. CySEC requires all regulated firms to appoint a qualified Compliance Officer.'
      },
      {
        question: 'How often must we submit regulatory reports to CySEC?',
        answer: 'Reporting frequency depends on your license type and activities. CySEC-regulated investment firms typically submit quarterly financial reports, annual audited accounts, transaction reports (daily for MiFID firms), and ad-hoc reports for significant events. We manage all reporting deadlines and ensure timely, accurate submissions to maintain regulatory compliance.'
      },
      {
        question: 'Can you help us prepare for a CySEC on-site inspection?',
        answer: 'Yes, we provide comprehensive preparation for CySEC inspections including documentation review, compliance gap analysis, staff training on regulatory expectations, preparation of response materials, and mock inspections to identify potential issues. Our team has extensive experience with CySEC inspection processes and can guide you through every step.'
      },
      {
        question: 'What are the penalties for non-compliance in Cyprus?',
        answer: 'CySEC has significant enforcement powers including administrative fines up to €5 million or 10% of annual turnover, license suspension or revocation, public warnings, and criminal prosecution for serious violations. FIAU can impose fines up to €5 million for AML breaches. Our compliance services help you avoid these penalties through proactive compliance management.'
      }
    ]
  },
  'tax-payroll-outsourcing': {
    id: 'tax-payroll-outsourcing',
    title: 'Tax & Payroll Outsourcing',
    subtitle: 'Comprehensive Tax Planning and Payroll Management for Cyprus Businesses',
    heroImage: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20financial%20growth%20concept%20with%20ascending%20golden%20geometric%20bars%20and%20flowing%20light%20streams%20representing%20wealth%20accumulation%20and%20tax%20optimization%20sleek%20glass%20surfaces%20reflecting%20Cyprus%20Mediterranean%20sunset%20warm%20amber%20and%20deep%20blue%20tones%20sophisticated%20corporate%20aesthetic&width=1920&height=600&seq=tax-hero&orientation=landscape',
    description: 'Cyprus has one of the best tax regimes in the EU. The corporate tax rate is just 12.5%. There are over 65 double tax treaties. The IP Box regime, notional interest deduction, and participation exemption offer further savings. But getting the most from these advantages requires expert guidance. We handle your tax planning, payroll, and compliance — so you benefit fully while staying on the right side of the rules.',
    longDescription: 'Cyprus tax law covers corporate tax, personal income tax, VAT, social insurance, and special defence contribution. Each has its own rules, deadlines, and filing requirements. Missing any of them leads to penalties.\n\nWe manage it all. We plan your corporate tax structure, process monthly payroll, file VAT returns, and handle social insurance contributions. We also advise on transfer pricing, tax residency, and incentive applications like the IP Box regime.\n\nFor international businesses, we ensure compliance with CRS, FATCA, and DAC6 reporting. One team, one point of contact — covering every tax obligation your Cyprus business has.',
    whyCyprus: {
      title: 'Why Cyprus Offers Exceptional Tax Advantages?',
      benefits: [
        {
          icon: 'ri-percent-line',
          title: 'Low Corporate Tax Rate',
          description: '12.5% corporate tax rate, one of the lowest in the EU, combined with no withholding taxes on dividend payments to non-residents and extensive double tax treaty network.'
        },
        {
          icon: 'ri-lightbulb-flash-line',
          title: 'IP Box Regime',
          description: 'Effective 2.5% tax rate on qualifying intellectual property income through 80% exemption, making Cyprus ideal for IP holding and licensing structures.'
        },
        {
          icon: 'ri-hand-coin-line',
          title: 'Participation Exemption',
          description: 'Dividends received from subsidiaries and capital gains from sale of shares are fully exempt from tax, enabling tax-efficient group structures and exits.'
        },
        {
          icon: 'ri-user-heart-line',
          title: 'Non-Dom Tax Status',
          description: 'Individuals can qualify for non-domiciled status, exempting them from special defence contribution on dividends, interest, and rental income for 17 years.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Tax Structure Review',
        description: 'We analyze your business structure, operations, and objectives to design optimal tax-efficient arrangements compliant with Cyprus and international tax laws.'
      },
      {
        step: '02',
        title: 'System Setup',
        description: 'Registration with Tax Department, VAT registration if required, social insurance registration, and setup of payroll systems and tax compliance calendars.'
      },
      {
        step: '03',
        title: 'Monthly Processing',
        description: 'Monthly payroll processing, social insurance calculations and payments, PAYE withholding, and preparation of payslips and statutory reports.'
      },
      {
        step: '04',
        title: 'Annual Compliance',
        description: 'Preparation and filing of corporate tax returns, personal tax returns, VAT returns, transfer pricing documentation, and coordination with auditors.'
      }
    ],
    subServices: [
      {
        icon: 'ri-building-line',
        title: 'Corporate Tax Planning',
        description: 'Strategic tax planning for Cyprus companies including group restructuring, IP migration, holding company structures, and utilization of tax incentives.'
      },
      {
        icon: 'ri-user-line',
        title: 'Personal Tax Advisory',
        description: 'Personal income tax planning for directors and employees, non-dom status applications, tax residency planning, and compliance with Cyprus tax obligations.'
      },
      {
        icon: 'ri-receipt-line',
        title: 'VAT Registration & Compliance',
        description: 'Cyprus VAT registration, quarterly VAT return preparation and filing, VIES reporting, and advisory on VAT treatment of cross-border transactions.'
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Payroll Processing',
        description: 'Complete monthly payroll processing including salary calculations, PAYE withholding, social insurance contributions, and electronic payslip distribution.'
      },
      {
        icon: 'ri-shield-user-line',
        title: 'Social Insurance Management',
        description: 'Registration and ongoing compliance with Cyprus Social Insurance Fund, including monthly contributions (8.3% employer, 8.3% employee, 4.7% self-employed).'
      },
      {
        icon: 'ri-file-text-line',
        title: 'Tax Return Preparation',
        description: 'Preparation and electronic filing of corporate tax returns (IR4), personal tax returns (IR1), and all supporting schedules and computations.'
      },
      {
        icon: 'ri-exchange-line',
        title: 'Transfer Pricing',
        description: 'Transfer pricing documentation, intercompany agreements, benchmarking studies, and compliance with OECD guidelines and Cyprus transfer pricing requirements.'
      },
      {
        icon: 'ri-gift-line',
        title: 'Tax Incentive Applications',
        description: 'Applications for IP Box regime, notional interest deduction, R&D incentives, and other Cyprus tax incentives to minimize effective tax rate.'
      }
    ],
    faqs: [
      {
        question: 'What is the total employment cost in Cyprus including social insurance?',
        answer: 'Total employment cost includes gross salary plus employer contributions: 8.3% social insurance, 2% cohesion fund, 1.2% redundancy fund, 0.5% training levy, 8% holiday fund, and 8% provident fund (if applicable). For a €50,000 annual salary, total employer cost is approximately €59,000. Employees pay 8.3% social insurance plus special defence contribution on certain income.'
      },
      {
        question: 'How does the Cyprus IP Box regime work?',
        answer: 'The IP Box regime provides an 80% exemption on qualifying IP income (royalties, capital gains from IP sale, embedded IP income), resulting in an effective 2.5% tax rate (20% of 12.5%). Qualifying IP includes patents, software, and other intangibles developed through R&D. The regime requires substance in Cyprus and compliance with OECD nexus approach linking tax benefits to actual R&D activity.'
      },
      {
        question: 'What are the VAT rates and thresholds in Cyprus?',
        answer: 'Standard VAT rate is 19%, with reduced rates of 9% (hospitality, transport) and 5% (specific goods). VAT registration is mandatory when annual turnover exceeds €15,600. Intra-EU supplies are zero-rated, and exports outside EU are exempt. We handle all VAT compliance including registration, quarterly returns, VIES reporting, and Intrastat declarations.'
      },
      {
        question: 'Can foreign directors benefit from Cyprus tax advantages?',
        answer: 'Yes, foreign individuals who become Cyprus tax residents (183+ days per year) can benefit from the non-dom regime, exempting dividends, interest, and rental income from special defence contribution for 17 years. Additionally, 50% of employment income exceeding €100,000 is exempt from tax for the first 10 years (for new residents starting employment after 2022). We assist with tax residency planning and compliance.'
      }
    ]
  },
  'accounting-outsourcing': {
    id: 'accounting-outsourcing',
    title: 'Accounting Outsourcing',
    subtitle: 'Professional Accounting and Financial Reporting Services for Cyprus Companies',
    heroImage: 'https://readdy.ai/api/search-image?query=Sophisticated%20modern%20office%20workspace%20with%20elegant%20financial%20charts%20and%20analytics%20displayed%20on%20sleek%20devices%20warm%20natural%20sunlight%20streaming%20through%20floor-to-ceiling%20windows%20overlooking%20Mediterranean%20Sea%20minimalist%20professional%20environment%20with%20premium%20materials%20glass%20and%20wood%20warm%20neutral%20tones%20representing%20financial%20excellence&width=1920&height=600&seq=accounting-hero&orientation=landscape',
    description: 'Good accounting keeps your business healthy and compliant. Cyprus law requires all companies to maintain proper books and prepare annual financial statements under IFRS. CySEC-regulated firms also need quarterly reports and capital adequacy calculations. We handle all of this for you — from daily bookkeeping to year-end accounts — so you always have accurate numbers and zero compliance stress.',
    longDescription: 'Cyprus combines international accounting standards with local filing rules. Missing deadlines with the Registrar of Companies leads to penalties. CySEC-regulated firms face even stricter requirements: quarterly reports, capital adequacy checks, and specific disclosures for financial instruments.\n\nOur team covers every stage. We record daily transactions, reconcile bank accounts, prepare management reports, and coordinate your annual audit. We work across financial services, gaming, shipping, and trading. Whatever your sector, we keep your books clean and your filings on time.',
    whyCyprus: {
      title: 'Why Cyprus Accounting Standards Support Business Growth?',
      benefits: [
        {
          icon: 'ri-global-line',
          title: 'International Standards',
          description: 'Cyprus requires IFRS or IFRS for SMEs for financial reporting, ensuring international credibility and comparability for investors, lenders, and business partners worldwide.'
        },
        {
          icon: 'ri-file-shield-line',
          title: 'Clear Regulatory Framework',
          description: 'Cyprus Companies Law Cap.113 and CySEC directives provide clear accounting requirements, filing deadlines, and audit obligations for different company types and sizes.'
        },
        {
          icon: 'ri-calculator-line',
          title: 'Simplified Compliance',
          description: 'Electronic filing systems, standardized chart of accounts, and clear guidance from ICPAC (Institute of Certified Public Accountants) simplify accounting compliance.'
        },
        {
          icon: 'ri-team-line',
          title: 'Professional Expertise',
          description: 'Cyprus has a large pool of qualified accountants, auditors, and financial professionals with international qualifications (ACCA, CPA, ICAEW) and multilingual capabilities.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Accounting Setup',
        description: 'We establish your chart of accounts, accounting policies, and procedures aligned with IFRS requirements and your business needs, and integrate with your banking and systems.'
      },
      {
        step: '02',
        title: 'Monthly Bookkeeping',
        description: 'Daily transaction recording, bank reconciliations, accounts payable and receivable management, expense tracking, and preparation of monthly management accounts.'
      },
      {
        step: '03',
        title: 'Financial Reporting',
        description: 'Preparation of monthly, quarterly, and annual financial statements including balance sheet, income statement, cash flow statement, and notes to accounts.'
      },
      {
        step: '04',
        title: 'Audit & Filing',
        description: 'Coordination with external auditors, preparation of audit schedules, resolution of audit queries, and filing of financial statements with Registrar of Companies.'
      }
    ],
    subServices: [
      {
        icon: 'ri-book-open-line',
        title: 'Bookkeeping Services',
        description: 'Daily recording of all financial transactions, bank reconciliations, accounts payable and receivable management, expense tracking, and maintenance of general ledger.'
      },
      {
        icon: 'ri-file-chart-line',
        title: 'Financial Reporting',
        description: 'Preparation of IFRS-compliant financial statements including balance sheet, income statement, statement of changes in equity, cash flow statement, and notes.'
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Management Accounts',
        description: 'Monthly management reports with key financial metrics, variance analysis, departmental reporting, and customized dashboards for informed decision-making.'
      },
      {
        icon: 'ri-file-search-line',
        title: 'Audit Coordination',
        description: 'Full coordination with external auditors including preparation of audit schedules, supporting documentation, resolution of queries, and implementation of recommendations.'
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Financial Statement Preparation',
        description: 'Year-end financial statement preparation in accordance with IFRS or IFRS for SMEs, including all required disclosures and notes to accounts.'
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Budget Planning & Analysis',
        description: 'Annual budget preparation, quarterly reforecasts, scenario analysis, and financial modeling to support strategic planning.'
      },
      {
        icon: 'ri-money-dollar-box-line',
        title: 'Cash Flow Management',
        description: 'Cash flow forecasting, working capital management, liquidity analysis, and recommendations for optimizing cash position and funding requirements.'
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Year-End Accounts',
        description: 'Complete year-end closing procedures, adjusting entries, depreciation calculations, provisions, accruals, and preparation of final accounts for audit.'
      }
    ],
    faqs: [
      {
        question: 'What accounting standards must Cyprus companies follow?',
        answer: 'Cyprus companies must prepare financial statements in accordance with International Financial Reporting Standards (IFRS) as adopted by the EU. Small companies may use IFRS for SMEs, which is a simplified framework. CySEC-regulated entities must follow specific accounting standards for financial instruments and regulatory reporting. All financial statements must be filed with the Registrar of Companies within 9 months of year-end.'
      },
      {
        question: 'Are all Cyprus companies required to have an audit?',
        answer: 'Not all companies require an audit. Small companies meeting two of three criteria (turnover &lt;€8.8M, assets &lt;€4.4M, employees &lt;50) may be exempt from statutory audit. However, CySEC-regulated entities, public companies, and companies exceeding the thresholds must have annual audits by Cyprus-registered auditors. We coordinate the entire audit process and ensure timely completion.'
      },
      {
        question: 'How often must CySEC-regulated firms submit financial reports?',
        answer: 'CySEC-regulated investment firms must submit quarterly financial reports within 30 days of quarter-end, including balance sheet, income statement, capital adequacy calculations, and client money reconciliations. Annual audited financial statements must be submitted within 4 months of year-end. We manage all regulatory reporting deadlines and ensure accurate, timely submissions.'
      },
      {
        question: 'Can you help with management accounting and budgeting?',
        answer: 'Yes, we provide comprehensive management accounting services including monthly management accounts with KPIs, departmental P&Ls, variance analysis against budget, cash flow forecasts, and customized dashboards. We also assist with annual budget preparation, quarterly reforecasts, scenario analysis, and financial modeling to support strategic decision-making and business planning.'
      }
    ]
  },
  'legal-drafting-outsourcing': {
    id: 'legal-drafting-outsourcing',
    title: 'Legal Drafting Outsourcing',
    subtitle: 'Expert Legal Documentation and Policy Development for Cyprus Businesses',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20sophisticated%20law%20office%20interior%20with%20elegant%20wooden%20desk%20premium%20leather-bound%20legal%20documents%20and%20golden%20scales%20of%20justice%20warm%20ambient%20lighting%20through%20tall%20windows%20overlooking%20Limassol%20Cyprus%20marina%20luxury%20professional%20legal%20environment%20deep%20mahogany%20and%20gold%20tones%20representing%20authority%20and%20precision&width=1920&height=600&seq=legal-hero&orientation=landscape',
    description: 'Every Cyprus business needs clear, up-to-date legal documents. You need employment contracts that meet Cyprus Labour Law. You need GDPR-compliant privacy policies. You need AML manuals that satisfy CySEC and FIAU. Getting these wrong is costly. We draft, review, and maintain all your legal documents — so they are always accurate, compliant, and ready to use.',
    longDescription: 'Cyprus law draws from English common law and EU directives. This means your documents must meet multiple overlapping standards. CySEC-regulated firms need MiFID II-compliant client agreements and compliance manuals. Gaming operators need responsible gaming policies and jurisdiction-specific terms. All companies need proper corporate governance records.\n\nWe handle the full range. AML/KYC policies, employment contracts, privacy policies, shareholder agreements, board minutes, commercial contracts — we draft them all. Our team combines legal expertise with practical business knowledge. Every document we produce is legally sound, regulator-ready, and written in plain language your team can actually follow.',
    whyCyprus: {
      title: 'Why Cyprus Legal Framework Supports Business Operations?',
      benefits: [
        {
          icon: 'ri-scales-3-line',
          title: 'English Common Law Foundation',
          description: 'Cyprus legal system based on English common law provides familiar framework for international businesses, with well-established case law and legal principles recognized globally.'
        },
        {
          icon: 'ri-earth-line',
          title: 'Full EU Legal Integration',
          description: 'As EU member state, Cyprus implements all EU directives including GDPR, MiFID II, PSD2, and company law directives, ensuring compliance across European markets.'
        },
        {
          icon: 'ri-shield-check-line',
          title: 'Strong IP Protection',
          description: 'Cyprus provides robust intellectual property protection through Patents Law, Trademarks Law, and Copyright Law, aligned with international conventions and EU standards.'
        },
        {
          icon: 'ri-file-text-line',
          title: 'Flexible Corporate Law',
          description: 'Cyprus Companies Law Cap.113 offers flexible corporate structures, simplified procedures for amendments, and clear governance requirements suitable for diverse business models.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Requirements Analysis',
        description: 'We conduct thorough analysis of your business model, regulatory obligations, and operational needs to identify all required legal documentation and policies.'
      },
      {
        step: '02',
        title: 'Document Drafting',
        description: 'Our legal team prepares comprehensive, tailored documents incorporating Cyprus law requirements, regulatory standards, and international best practices.'
      },
      {
        step: '03',
        title: 'Review & Refinement',
        description: 'Collaborative review process with your team to ensure documents align with business operations, address practical concerns, and meet all legal requirements.'
      },
      {
        step: '04',
        title: 'Implementation & Updates',
        description: 'Support with document implementation, staff training on new policies, and ongoing updates to reflect regulatory changes and business evolution.'
      }
    ],
    subServices: [
      {
        icon: 'ri-shield-check-line',
        title: 'AML/KYC Policies & Procedures',
        description: 'Comprehensive AML compliance manuals, KYC procedures, risk assessment methodologies, and suspicious activity reporting protocols compliant with Cyprus AML Law 188(I)/2007 and FIAU requirements.'
      },
      {
        icon: 'ri-file-list-line',
        title: 'Terms & Conditions',
        description: 'Website terms of use, service agreements, platform terms and conditions for financial services, gaming, e-commerce, and SaaS businesses compliant with Cyprus and EU consumer protection laws.'
      },
      {
        icon: 'ri-lock-password-line',
        title: 'Privacy Policies',
        description: 'GDPR-compliant privacy policies, cookie policies, data processing agreements, and data subject rights procedures for websites, apps, and business operations.'
      },
      {
        icon: 'ri-user-settings-line',
        title: 'Employment Contracts',
        description: 'Employment agreements, executive contracts, contractor agreements, and employee handbooks compliant with Cyprus Labour Law, social insurance requirements, and employment regulations.'
      },
      {
        icon: 'ri-file-paper-line',
        title: 'Service Agreements',
        description: 'Commercial service agreements, supplier contracts, distribution agreements, agency agreements, and partnership contracts tailored to your business relationships and Cyprus contract law.'
      },
      {
        icon: 'ri-file-edit-line',
        title: 'Board Minutes & Resolutions',
        description: 'Board meeting minutes, shareholder resolutions, director appointments, share transfers, and all corporate governance documentation required under Cyprus Companies Law Cap.113.'
      },
      {
        icon: 'ri-group-line',
        title: 'Shareholder Agreements',
        description: 'Comprehensive shareholder agreements, articles of association amendments, voting rights arrangements, drag-along and tag-along provisions, and exit mechanisms.'
      },
      {
        icon: 'ri-briefcase-line',
        title: 'Commercial Contracts',
        description: 'Sales agreements, purchase contracts, licensing agreements, franchise agreements, joint venture agreements, and other commercial contracts for Cyprus and international transactions.'
      }
    ],
    faqs: [
      {
        question: 'What AML policies are required for Cyprus financial services companies?',
        answer: 'Cyprus financial services companies regulated by CySEC or FIAU must maintain comprehensive AML compliance manuals covering customer due diligence procedures, enhanced due diligence for high-risk customers, ongoing monitoring, sanctions and PEP screening, suspicious activity reporting to MOKAS, record-keeping, staff training, and risk assessment methodologies. We prepare complete AML manuals compliant with Cyprus AML Law 188(I)/2007, EU 5th AML Directive, and FIAU guidance.'
      },
      {
        question: 'Are employment contracts mandatory in Cyprus?',
        answer: 'Yes, Cyprus Labour Law requires written employment contracts for all employees, specifying job title, duties, salary, working hours, leave entitlements, notice periods, and termination conditions. Contracts must comply with minimum wage requirements, social insurance obligations, and employment protection legislation. We draft comprehensive employment contracts and employee handbooks covering all legal requirements and best practices.'
      },
      {
        question: 'What corporate governance documents must Cyprus companies maintain?',
        answer: 'Cyprus companies must maintain memorandum and articles of association, register of members, register of directors and secretary, register of charges, minutes of board meetings and general meetings, and annual returns filed with Registrar of Companies. CySEC-regulated firms have additional requirements for compliance manuals, risk management policies, and internal procedures. We prepare and maintain all required corporate governance documentation.'
      },
      {
        question: 'How often should legal documents and policies be updated?',
        answer: 'Legal documents should be reviewed annually and updated whenever there are regulatory changes, business model changes, or new legal requirements. GDPR policies require updates when data processing activities change. AML policies must reflect current FIAU guidance and regulatory expectations. Employment contracts should be reviewed when labour law changes. We provide ongoing legal document maintenance and update services to ensure continuous compliance.'
      }
    ]
  },
  'company-formation': {
    id: 'company-formation',
    title: 'Company Formation Services',
    subtitle: 'Fast and Efficient Cyprus Company Registration and Corporate Services',
    heroImage: 'https://readdy.ai/api/search-image?query=Stunning%20modern%20glass%20and%20steel%20corporate%20headquarters%20building%20in%20Limassol%20Cyprus%20financial%20district%20at%20golden%20hour%20with%20dramatic%20angular%20architecture%20reflecting%20vibrant%20sunset%20colors%20Mediterranean%20Sea%20visible%20in%20background%20sleek%20professional%20business%20aesthetic%20representing%20corporate%20excellence%20and%20innovation%20warm%20amber%20and%20deep%20blue%20tones&width=1920&height=600&seq=formation-hero&orientation=landscape',
    description: 'Cyprus is one of Europe\'s top destinations for company formation. Registration takes just 5–7 business days. The corporate tax rate is 12.5% — the lowest in the EU. You get access to the EU single market and a network of over 65 double tax treaties. We guide you through every step, from choosing the right structure to opening your bank account.',
    longDescription: 'Setting up a Cyprus company is straightforward when you know the process. You need a company name, a memorandum and articles of association, at least one director, and a registered office address. We handle all of it.\n\nCyprus allows 100% foreign ownership. You can have a single director. Nominee director services are available for privacy. The jurisdiction suits holding companies, trading firms, investment firms, gaming operators, and IP structures.\n\nOnce your company is registered, we keep it compliant. We provide company secretary services, registered office in Limassol, annual filings, and corporate restructuring support. One team handles everything — from day one and beyond.',
    whyCyprus: {
      title: 'Why Choose Cyprus for Company Formation?',
      benefits: [
        {
          icon: 'ri-time-line',
          title: 'Fast Incorporation Process',
          description: 'Cyprus company registration typically completed within 5-7 business days from submission of all required documents and information. This includes name reservation (1-2 days), document preparation and notarization (1-2 days), and registration with Registrar of Companies (3-5 days). Expedited service is available for urgent cases. After incorporation, additional time is required for tax registration, VAT registration, and bank account opening.'
        },
        {
          icon: 'ri-percent-line',
          title: 'Lowest EU Corporate Tax',
          description: '12.5% corporate tax rate, one of the lowest in the EU, combined with participation exemption on dividends, no withholding taxes on outbound dividends, and extensive double tax treaty network.'
        },
        {
          icon: 'ri-global-line',
          title: 'EU Member State Benefits',
          description: 'Full access to EU single market, freedom of establishment across EU member states, EU passporting rights for regulated activities, and compliance with EU legal and regulatory standards.'
        },
        {
          icon: 'ri-shield-star-line',
          title: 'Strong Legal Framework',
          description: 'Cyprus Companies Law Cap.113 based on English common law provides clear corporate governance rules, shareholder protection, flexible structures, and internationally recognized legal framework.'
        }
      ]
    },
    processSteps: [
      {
        step: '01',
        title: 'Structure Planning',
        description: 'We advise on optimal corporate structure, share capital, director and shareholder arrangements, and jurisdiction selection based on your business objectives and tax planning needs.'
      },
      {
        step: '02',
        title: 'Name Reservation & Documentation',
        description: 'Company name search and reservation with Registrar of Companies, preparation of memorandum and articles of association, and all required incorporation documents.'
      },
      {
        step: '03',
        title: 'Registration & Compliance',
        description: 'Filing with Registrar of Companies, obtaining certificate of incorporation, tax identification number, VAT registration if required, and social insurance registration.'
      },
      {
        step: '04',
        title: 'Post-Incorporation Services',
        description: 'Bank account opening assistance, registered office provision, company secretary appointment, corporate kit preparation, and setup of accounting and compliance systems.'
      }
    ],
    subServices: [
      {
        icon: 'ri-building-line',
        title: 'Cyprus Company Formation',
        description: 'Complete incorporation of Cyprus private limited companies including name reservation, document preparation, registration with Registrar of Companies, and certificate of incorporation within 5-7 days.'
      },
      {
        icon: 'ri-map-pin-line',
        title: 'Malta Company Formation',
        description: 'Malta private limited company formation for gaming operators, financial services, and trading companies, with Malta tax refund system providing effective 5% corporate tax rate.'
      },
      {
        icon: 'ri-flag-line',
        title: 'UK Company Formation',
        description: 'UK limited company formation for businesses requiring UK presence, access to UK banking, or UK corporate structure for international operations and e-commerce activities.'
      },
      {
        icon: 'ri-home-office-line',
        title: 'Registered Office Services',
        description: 'Provision of prestigious registered office address in Limassol Cyprus business district, mail handling, forwarding services, and compliance with Companies Law requirements.'
      },
      {
        icon: 'ri-user-star-line',
        title: 'Nominee Director Services',
        description: 'Professional nominee director services for privacy and confidentiality, with experienced Cyprus-resident directors, full indemnities, and powers of attorney arrangements.'
      },
      {
        icon: 'ri-file-user-line',
        title: 'Company Secretary Services',
        description: 'Qualified company secretary services ensuring compliance with Cyprus Companies Law, maintenance of statutory registers, preparation of board minutes and resolutions, and annual return filings.'
      },
      {
        icon: 'ri-node-tree',
        title: 'Corporate Restructuring',
        description: 'Corporate reorganizations, mergers and acquisitions support, share transfers, capital increases and reductions, amendments to articles of association, and group restructuring.'
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Annual Compliance Filings',
        description: 'Annual return preparation and filing with Registrar of Companies, maintenance of statutory registers, registered office compliance, and all ongoing corporate compliance obligations.'
      }
    ],
    faqs: [
      {
        question: 'How long does it take to form a Cyprus company?',
        answer: 'Standard Cyprus company formation typically takes 5-7 business days from submission of all required documents and information. This includes name reservation (1-2 days), document preparation and notarization (1-2 days), and registration with Registrar of Companies (3-5 days). Expedited service is available for urgent cases. After incorporation, additional time is required for tax registration, VAT registration, and bank account opening.'
      },
      {
        question: 'What are the minimum requirements for a Cyprus company?',
        answer: 'Cyprus private limited company requires minimum one director (can be foreign resident), minimum one shareholder (can be same person as director or corporate shareholder), minimum share capital of €1 (can be increased), company secretary (can be individual or corporate), and registered office address in Cyprus. No minimum paid-up capital is required. We can provide nominee director, company secretary, and registered office services.'
      },
      {
        question: 'Can foreigners own 100% of a Cyprus company?',
        answer: 'Yes, Cyprus allows 100% foreign ownership of companies with no restrictions on nationality or residency of shareholders and directors. Foreign individuals and companies can freely establish and own Cyprus companies. However, certain regulated activities (banking, insurance, investment services) require regulatory approval and may have additional requirements. We assist with structuring and compliance for all business types.'
      },
      {
        question: 'What ongoing compliance is required for Cyprus companies?',
        answer: 'Cyprus companies must file annual returns with Registrar of Companies, maintain statutory registers at registered office, hold annual general meetings, prepare annual financial statements in accordance with IFRS, file financial statements with Registrar within 9 months of year-end, and submit annual tax returns. Companies must also maintain adequate accounting records and comply with social insurance and VAT obligations. Our annual compliance services ensure all obligations are met on time.'
      }
    ]
  }
};